var map = {
	"./IMG_0470.webp": 771,
	"./IMG_0472.webp": 328,
	"./IMG_0474.webp": 564,
	"./IMG_0475.webp": 828,
	"./IMG_0476.webp": 43,
	"./IMG_0477.webp": 693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 224;